import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './OrderPanelCtaInfo.module.css';
import Icons from '../../../components/Icons/Icons';
import AuctionPricingSummary from '../../../components/AuctionPricingSummary/AuctionPricingSummary';

const pad2 = n => String(n).padStart(2, '0');

const OrderPanelCtaInfo = props => {
  const {
    intl,

    // content
    titleNode, // optional: if you want to show title here too
    showListingImage,

    // auction flags
    auctionEnabled,
    countdown,
    endsLabel,

    // listing metadata
    shortDescriptionLine,

    // verified + live auction badges
    showLiveAuction,
    showVerified = true,

    // prices
    listing,
    userBids,
    price,
    publicData,
    validListingTypes,
    marketplaceCurrency,
    showSellerCommission = false,

    // if you want the PriceMaybe behavior
    PriceMaybeComponent,
    showCurrencyMismatch = false,
  } = props;

  return (
    <>
      {/* Optional title */}
      {titleNode ? <div className={css.modalHeading}>{titleNode}</div> : null}

      {/* Badges */}
      <div className={css.liveAuctionSec}>
        {showLiveAuction ? (
          <span className={css.liveAuction}>
            <Icons name="signal" />
            <FormattedMessage id="OrderPanel.auction.live" defaultMessage="Live Timed Sale" />
          </span>
        ) : null}

        {/* {showVerified ? (
          <span className={css.verifiedAuthentic}>
            <Icons name="verifyOutline" />
            <FormattedMessage id="OrderPanel.verified" defaultMessage="Verified Authentic" />
          </span>
        ) : null} */}
      </div>

      {/* Description line */}
      {shortDescriptionLine ? <div className={css.description}>{shortDescriptionLine}</div> : null}

      {/* Price block (reuse your existing PriceMaybe to keep logic consistent) */}
      {PriceMaybeComponent ? (
        <PriceMaybeComponent
          price={price}
          publicData={publicData}
          validListingTypes={validListingTypes}
          intl={intl}
          marketplaceCurrency={marketplaceCurrency}
          showCurrencyMismatch={showCurrencyMismatch}
        />
      ) : null}

      {auctionEnabled ? (
        <AuctionPricingSummary
          className={css.auctionPricingSummary}
          listing={listing}
          userBids={userBids}
          publicData={publicData}
          marketplaceCurrency={marketplaceCurrency}
          intl={intl}
          showSellerCommission={showSellerCommission}
        />
      ) : null}

      {/* Auction countdown */}
      {auctionEnabled ? (
        <div className={css.timeRemainingSec}>
          <div className={css.time}>
            <span>
              <FormattedMessage id="OrderPanel.timeRemaining" defaultMessage="Time Remaining" />
            </span>
            <span className={css.endsLabel}>
              {countdown?.isEnded ? (
                <FormattedMessage id="OrderPanel.ended" defaultMessage="Ended" />
              ) : (
                <FormattedMessage
                  id="OrderPanel.endsOn"
                  defaultMessage="Ends {dateLabel}"
                  values={{ dateLabel: endsLabel || '-' }}
                />
              )}
            </span>
          </div>

          {!countdown?.isEnded ? (
            <div className={css.timerSec}>
              <div className={css.timeCount}>
                <span className={css.count}>{pad2(countdown?.days || 0)}</span>
                <span>
                  <FormattedMessage id="OrderPanel.days" defaultMessage="Days" />
                </span>
              </div>

              <span className={css.separator}>:</span>

              <div className={css.timeCount}>
                <span className={css.count}>{pad2(countdown?.hrs || 0)}</span>
                <span>
                  <FormattedMessage id="OrderPanel.hrs" defaultMessage="HRS" />
                </span>
              </div>

              <span className={css.separator}>:</span>

              <div className={css.timeCount}>
                <span className={css.count}>{pad2(countdown?.mins || 0)}</span>
                <span>
                  <FormattedMessage id="OrderPanel.mins" defaultMessage="Mins" />
                </span>
              </div>

              <span className={css.separator}>:</span>

              <div className={css.timeCount}>
                <span className={css.count}>{pad2(countdown?.secs || 0)}</span>
                <span>
                  <FormattedMessage id="OrderPanel.secs" defaultMessage="Secs" />
                </span>
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default OrderPanelCtaInfo;
